// Lines the cart builder has squish-backend price before they go in the cart.
//
// The renewal, standalone AI Visibility and owned-plan add-on sections build
// only the line's intent (what is being sold, for which domain). They send it
// to POST /api/carts/quote (squish-crm-backend → squish-backend
// /api/v2/internal/carts/quote), which prices it the way checkout will and
// answers with the normalized line. That line goes in the cart UNCHANGED, plus
// the builder's own lineId, so the price the rep reads out is the price the
// customer is charged. A refusal (409 PRICE_UNAVAILABLE) is a sentence written
// for the rep; it reaches the section as the Error's message.

// The cart items for a quote response, or a throw. Never adds a line the
// server did not price: a missing, short or unpriced answer is an error, not a
// $0 line.
export function pricedItems(response, lineIds) {
  const lines = response?.items;
  if (!Array.isArray(lines) || lines.length !== lineIds.length) {
    throw new Error('The price came back incomplete, so nothing was added. Try again.');
  }
  return lines.map((line, n) => {
    if (!line || typeof line !== 'object' || !Number.isFinite(line.unitPrice) || line.unitPrice < 0) {
      throw new Error('The price came back incomplete, so nothing was added. Try again.');
    }
    return { ...line, lineId: lineIds[n] };
  });
}

// Price one line for this cart and return the cart item for it.
//   quote      the api.js quoteCartLines (injected, so this is testable)
//   prospect   set on a prospect cart: there is no account yet, only an email
export async function priceLine({ quote, line, lineId, accountId, prospect }) {
  const who = prospect ? { prospect: { email: prospect.email } } : { accountId };
  const response = await quote({ items: [line], ...who });
  return pricedItems(response, [lineId]);
}

// What a section shows from the account's products (listAccountProducts):
// the rows it picked, or an error. A list that came back SHORT (one product
// source failed: productsComplete false) and has none of the rows wanted is
// not proof the customer owns none, so it reads as an error, not as "none".
export function ownedRowsState(rows, productsComplete) {
  return rows.length === 0 && productsComplete === false
    ? { error: 'some of their products could not be read' }
    : rows;
}
